import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { getStoredToken } from "@/api-services/config";

const LOGIN_PATH = '/login';

function redirectToLogin() {
  localStorage.removeItem('auth_user');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('authToken');
  sessionStorage.removeItem('auth_user');
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('authToken');
  if (window.location.pathname !== LOGIN_PATH) {
    window.location.href = LOGIN_PATH;
  }
}

// Global fetch interceptor — injects Bearer token and handles 401 by redirecting to login
const originalFetch = window.fetch;
window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const isExternal = /^https?:\/\//i.test(url) && !url.startsWith(window.location.origin);

  if (!isExternal) {
    const token = getStoredToken();
    if (token) {
      init = {
        ...init,
        headers: {
          ...(init?.headers as Record<string, string> || {}),
          Authorization: `Bearer ${token}`, // always wins over any stale cached header
        },
      };
    }
  }

  const response = await originalFetch(input, init);

  if (!isExternal && response.status === 401) {
    redirectToLogin();
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
